const COMPRESSION_THRESHOLD_BYTES = 64 * 1024;

const bytesToBase64 = (bytes) => {
  let binary = '';
  const chunkSize = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }
  return btoa(binary);
};

// Azure Static Web Apps applies its request-size limit before the drafts
// function can gzip the payload for Blob Storage. Compress large drafts in the
// browser and wrap them in JSON so they cross that ingress boundary safely.
const gzipJson = async (json) => {
  if (typeof CompressionStream === 'undefined') return null;
  const compressedStream = new Blob([json])
    .stream()
    .pipeThrough(new CompressionStream('gzip'));
  return new Uint8Array(await new Response(compressedStream).arrayBuffer());
};

export const encodeDraftRequest = async (draft, compress = gzipJson) => {
  const json = JSON.stringify(draft);
  if (json.length < COMPRESSION_THRESHOLD_BYTES) return json;

  const compressed = await compress(json);
  if (!compressed) return json;
  return JSON.stringify({
    draftEncoding: 'gzip-base64',
    data: bytesToBase64(compressed)
  });
};
